import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import {
  debounceTime,
  map,
  of,
  startWith,
  switchMap,
  tap,
  withLatestFrom
} from 'rxjs';
import { ContactService } from '../../services/contact.service';
import { Contact } from 'src/app/models/contact';

interface SelectContactState {
  customerId: number;
  selectedContact: Contact;
  searchResults: Contact[];
}

const initialState: SelectContactState = {
  customerId: 0,
  selectedContact: null,
  searchResults: []
};

@Injectable()
export class SelectContactStoreService extends ComponentStore<SelectContactState> {
  constructor(private contactService: ContactService) {
    super(initialState);
  }

  readonly setCustomerId = this.updater((state, customerId: number) => ({
    ...state,
    customerId
  }));

  private readonly customerId$ = this.select((state) => state.customerId);

  private readonly customerContacts$ = this.customerId$.pipe(
    switchMap((customerId) => {
      return this.contactService.getForCustomer(customerId);
    })
  );

  readonly searchResults$ = this.select((state) => state.searchResults);
  readonly selectedContact$ = this.select((state) => state.selectedContact);

  readonly search = this.effect<string>((searchTerm$) => {
    return searchTerm$.pipe(
      startWith(''),
      withLatestFrom(this.customerContacts$, this.customerId$),
      debounceTime(500),
      switchMap(([searchTerm, customerContacts, customerId]) => {
        console.log({ searchTerm, customerContacts, customerId });
        if (!searchTerm) {
          return of(customerContacts);
        }
        // search for contacts
        return this.getSearchResults(searchTerm, customerId);
      }),
      tap((searchResults: Contact[]) => {
        this.patchState({ searchResults });
      })
    );
  });

  readonly setSelectedContact = this.updater((state, selectedContact: any) => ({
    ...state,
    selectedContact
  }));

  private getSearchResults(searchTerm: string, customerId: number) {
    const searchQuery = this.contactService.search(searchTerm);

    // sort by customer contacts first, then everyhting else
    return searchQuery.pipe(
      map((results) => {
        console.log({ results, customerId });
        return results.sort((a, b) => {
          if (a.customer_ids.indexOf(customerId) > -1) {
            return -1;
          }
          return 1;
        });
      })
    );
  }
}
